import { render, staticRenderFns } from "./surplus-retrieval-modal.vue?vue&type=template&id=cf165708&scoped=true&lang=pug&"
import script from "./surplus-retrieval-modal.vue?vue&type=script&lang=js&"
export * from "./surplus-retrieval-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf165708",
  null
  
)

export default component.exports